import { useMutation } from '@tanstack/react-query';

import { fetchClient } from '@/lib/openapi-fetch/fetchClient';
import { candidateEndpoints } from '@/modules/candidates/constants';
import { candidateJobQueryKeys } from '@/modules/candidates/queries/queryKeys';
import type { CandidateJobHiringStatusRequestApi } from '@/modules/candidates/types';
import { invalidateQuery } from '@/utils/queries';

export const useUpdateCandidateJobHiringStatusMutation = (
  jobId: string,
  candidateId: string,
) => {
  return useMutation({
    mutationFn: async (body: CandidateJobHiringStatusRequestApi) => {
      const { data } = await fetchClient.PUT(
        candidateEndpoints.candidateJobHiringStatus,
        {
          params: {
            path: {
              jobId,
              candidateId,
            },
          },
          body,
        },
      );
      return data;
    },
    onSettled: () => {
      const detailQueryKey = candidateJobQueryKeys.detail(jobId, candidateId);
      const listQueryKey = candidateJobQueryKeys.lists(jobId);

      invalidateQuery(detailQueryKey)();
      invalidateQuery(listQueryKey)();
    },
  });
};
